import React, { Suspense, lazy, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useRoutes, Navigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Preloader from "./Components/Preloader/Preloader";
// import PrivateRoute from "./Components/ProtectedPages";
// Disabled: partner suspended activities, access blocked pending reinstatement
// import CorperWalletRoutes from "./Pages/Corper-Wallet/routes/CorperWalletRoutes";
import JobsRoutes from "./Pages/Job Admin/routes/JobsRoutes";
import YouthplusSupport from "./Pages/Support/YouthplusSupport";
import { initializeMixpanel } from "./utils/mixpanel";
// import HtmlPdfSTring from "./helper/htmlPdfSTring";

// Lazy load pages
const LandingPage = lazy(() => import("./Pages/Landing Page/LandingPage"));
const Partners = lazy(() => import("./Pages/Partners/partners"));
const SignUpYouthplus = lazy(() => import("./Pages/SignUpYouthplus/"));
const PrivacyPolicy = lazy(() => import("./Pages/PrivacyPolicy"));
const Terms = lazy(() => import("./Pages/Terms"));
const StanbicAccountForm = lazy(() =>
  import("./Pages/StanbicIbtcForm/stanbicForm")
);
const StanbicTerms = lazy(() => import("./Components/StanbicTerm"));
const Transport = lazy(() =>
  import("./Pages/TransportIntegration/pages/Transport")
);
const BookTrip = lazy(() =>
  import("./Pages/TransportIntegration/pages/BookTrip/")
);
const TripDetails = lazy(() =>
  import("./Pages/TransportIntegration/pages/TripDetails")
);
const PassengersDetails = lazy(() =>
  import("./Pages/TransportIntegration/pages/PassengersDetail")
);
const Support = lazy(() => import("./Pages/Support/support"));
const History = lazy(() =>
  import("./Pages/TransportIntegration/pages/History/History")
);
const AdminDashboard = lazy(() => import("./Pages/AdminDashboard/Dashboard"));
const ForgotPassword = lazy(() =>
  import("./Pages/ForgotPassword/forgotPassword")
);
const ResetPassword = lazy(() =>
  import("./Pages/ForgotPassword/ResetPassword")
);
const NotFound = lazy(() => import("./Pages/NotFound"));

// Partner suspended activities: redirect any Corper Wallet link straight to
// the home page instead of a generic 404, so old bookmarks/marketing links
// don't read as the site being broken.
const CorperWalletRedirect = () => {
  useEffect(() => {
    toast.info("Corper Wallet is temporarily unavailable.");
  }, []);
  return <Navigate to="/" replace />;
};

function App() {
  toast.configure({
    autoClose: 7000, // 7 seconds
  });

  // Initialize Mixpanel tracking
  useEffect(() => {
    // Track app initialization
    initializeMixpanel();
  }, []);

  const routing = useRoutes([
    { path: "/", element: <LandingPage /> },
    { path: "/partners", element: <Partners /> },
    { path: "/nysc-onboarding", element: <SignUpYouthplus /> },
    { path: "*", element: <NotFound /> },
    { path: "/nysc-onboarding/:email/:call", element: <SignUpYouthplus /> },
    { path: "/nysc-onboarding/:email", element: <SignUpYouthplus /> },
    // {
    //   path: "/get-payment-status/<str:paymentReference>/?code",
    //   element: <Transport />,
    // },
    { path: "/policy", element: <PrivacyPolicy /> },
    { path: "/terms", element: <Terms /> },
    {
      path: "/complete-stanbicibtc-registration",
      element: <StanbicAccountForm />,
    },
    { path: "/stanbicterms", element: <StanbicTerms /> },
    { path: "/transport", element: <Transport /> },
    { path: "/book-trips", element: <BookTrip /> },
    { path: "/trip-details", element: <TripDetails /> },
    { path: "/trip-summary", element: <PassengersDetails /> },
    { path: "/transport-support", element: <Support /> },
    { path: "/support", element: <YouthplusSupport /> },
    { path: "/booking-history", element: <History /> },
    // { path: "/pdf-view", element: <HtmlPdfSTring /> },

    // Corper Wallet Loan Application Flow
    // Disabled: partner suspended activities, access blocked pending reinstatement
    // ...CorperWalletRoutes,
    { path: "/corper-wallet/*", element: <CorperWalletRedirect /> },
    ...JobsRoutes,

    // Authenticated Routes
    // {
    //   element: <PrivateRoute />,
    //   children: [{ path: "/booking-history", element: <History /> }],
    // },

    // Admin Routes
    { path: "/partner-dashboard", element: <AdminDashboard /> },
    { path: "/forgot-password", element: <ForgotPassword /> },
    { path: "/reset-password", element: <ResetPassword /> },
    { path: "/signup-youthplus", element: <SignUpYouthplus /> },
  ]);

  return (
    <div>
      <ToastContainer position="top-center" />

      {/* Wrap the routes with Suspense and show a preloader while pages load */}
      <Suspense fallback={<Preloader />}>{routing}</Suspense>
    </div>
  );
}

export default App;
